import { Observable } from 'rxjs/Observable'
import 'rxjs/add/observable/from'
import 'rxjs/add/observable/fromEvent'
import 'rxjs/add/observable/fromEventPattern'
import 'rxjs/add/observable/of'
import 'rxjs/add/observable/empty'
import 'rxjs/add/operator/skipWhile'
import 'rxjs/add/operator/debounceTime'
import 'rxjs/add/operator/mergeMap'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/do'
import 'rxjs/add/operator/first'
import 'rxjs/add/operator/merge'
import eventsCondition from 'ol/events/condition'
import 'UI/Util/FullScreen'
import 'GIS/UI/Map'
import 'GIS/Map/OL3'
import 'GIS/Map/Layer/MapBox'
import 'GIS/Map/Layer/OSM'
import 'GIS/Map/Layer/GlonassVector'
import 'GIS/Geometry'
import 'Spatial/Data/Objects'
import 'Spatial/Data/Classes'
import 'Spatial/Security'
import 'System/Promises'
import 'Dict/Data/DynRecords'
import './Input'
import 'UI/Widget/Forms/Control/Datepicker'
import 'UI/Widget/Forms/Control/Container'

/** @namespace UI.Widget.Forms.Control */
NS('UI.Widget.Forms.Control')

/**
 * @class
 * @extends UI.Widget.Forms.Control.Element
 *
 * todo переключать режим редактирования при выходе из fullscreen браузером и через esc
 */
UI.Widget.Forms.Control.FeatureMulti = Class(UI.Widget.Forms.Control.Element, System.Promises,
    /** @lends UI.Widget.Forms.Control.FeatureMulti.prototype */
    {
        template: 'UI/Widget/Forms/Control/FeatureMulti/Control',
        $selector: null,
        $map: null,
        $mapModeButton: null,
        $unbindButton: null,
        $featureInfo: null,
        $search: null,
        $spinner: null,
        /**
         * @type {GIS.UI.Map}
         * @protected
         */
        map: null,
        /**
         * @type {Data.ServerSource}
         * @protected
         */
        featuresSource: null,
        /**
         * @type {GIS.Map.Layer.Base}
         * @protected
         */
        currentLayer: null,
        /**
         * @type {ol.Feature}
         * @protected
         */
        currentFeature: null,
        /**
         * @type {Object}
         * @protected
         */
        searchAttribute: null,

        modeMap: null,
        smartControl: true, //todo: to interface

        currentClass: null,
        sourceAttribute: null,
        sourceAttributeDict: [],

        classesSource: null,
        classesSourceClass: 'Spatial.Data.Classes',
        objectsSourceClass: "Spatial.Data.Objects",
        objectsSource: null,
        classSecurityKey: "Spatial.Classes",


        initialize (parent, options = {}) {
            this.modeMap = this.Class.Mode.View
            this.Parent(parent, options)
            this.objectsSource = Util.create(this.objectsSourceClass)
            this.classesSource = Util.create(this.classesSourceClass)
            this.classesSource.getDocument({id: _.first(JSON.parse(this.$control.attr('layer')))}, ({item}) => {
                this.currentClass = item;
                this.sourceAttribute =_.find(this.currentClass.attributes, (a)=>{return a["alias"]=='source'})

                if (!this.sourceAttribute) return

                var records = Util.create(Dict.Data.DynRecords);

                records.page({'options[filter][dictid]': this.sourceAttribute.options.dict}, ({items}) => {
                    this.sourceAttributeDict = items;
                })
            });


        },
        setMode (mode) { //todo: to interface
            this.mode = mode

            if (this.mode === this.Class.Mode.View) {
                if (this.modeMap === this.Class.Mode.Edit) {
                    this.onEditClick()
                }
                this.$mapModeButton.hide()
                this.$unbindButton.hide()
            } else {
                this.$mapModeButton.show()
                this.$unbindButton.show()
            }
        },
        canDrawObjects(){
            return this.map && this.currentClass && Spatial.Security.checkItemAccess(
                this.currentClass,
                this.classSecurityKey,
                [Security.AccessMode.Insert, Security.AccessMode.Update, Security.AccessMode.Remove],
                [Security.AclAction.Write, Security.AclAction.Remove]
            );
        },
        createElement () {
            const title = JSON.parse(this.$control.attr('html-title'))
            const source = _.map(JSON.parse(this.$control.attr('target')), (value, key) => ({
                'title': title[ key ],
                'value': value
            }))
            // Поиск
            let searchAttribute = this.$control.attr('searchattribute')
            if (searchAttribute) {
                try {
                    searchAttribute = JSON.parse(searchAttribute)
                } catch (err) {}

                searchAttribute = _.first(searchAttribute || [])

                if (_.isPlainObject(searchAttribute)) this.searchAttribute = searchAttribute
            }

            this.$element = UI.Template.$render(this.template, {
                control: this,
                source,
                title
            })
            this.$selector = this.$name('selector')
            this.$mapModeButton = this.$name('map-mode')
            this.$unbindButton = this.$name('unbind')
            this.$map = this.$name('feature-map')
            this.$featureInfo = this.$name('feature-info')
            this.$search = this.$name('search')
            this.$spinner = this.$name('feature_spinner')

            var self = this;

            this.$element.click(function (e) {
                if (!e.isDefaultPrevented()) {
                    $('.to').hide()
                    $('.from').hide()
                }
            }.bind());

            this.$name('from').on('focus', function () {
                $('.to').hide()
                $('.from').show()
            }.bind());
            this.$name('to').on('focus', function () {
                $('.from').hide()
                $('.to').show()
            }.bind());
            this.$('.from,.to,[name=from],[name=to]').click(function (e) {
                e.preventDefault()
            })

            this.$('.from').datepicker({
                dateFormat: 'yy-mm-dd'
            }).on("change", function() {
                var filter = _.get(self.currentLayer, 'filter_') || {}
                if (!filter['createddatetime']) filter['createddatetime'] = {}
                filter['createddatetime']['from'] = this.value
                $('.from').hide()
                self.$name('from').val(this.value)
                self.currentLayer && self.currentLayer.filter(filter)
            });
            this.$('.to').datepicker({
                dateFormat: 'yy-mm-dd'
            }).on("change", function() {
                var filter = _.get(self.currentLayer, 'filter_') || {}
                if (!filter['createddatetime']) filter['createddatetime'] = {}
                filter['createddatetime']['to'] = this.value
                $('.to').hide()
                self.$name('to').val(this.value)
                self.currentLayer && self.currentLayer.filter(filter)
            });

            this.$selector.on('change', () => {
                this.setCurrentTarget()
                this.initLayer(this.map)
            })

            this.$mapModeButton.on('click', ::this.onEditClick)
            this.$unbindButton.on('click', () => {
                if (this.currentLayer && this.currentFeature) {
                    this.currentLayer.setFeatureStyleName(this.currentFeature, 'default', 'default')
                    this.currentLayer.filter(null)
                    this.currentFeature = null
                    this.updateFeatureInfo()
                }
                this.setValue(null, true)
            })

            // Инициализация поиска
            if (this.searchAttribute) {
                const attributeHelper = _.get(this.parent, this.$control.attr('attribute-helper'))
                // подписка на инпут запроса
                this._searchInputSubscription = Observable.fromEvent(this.$search, 'input', evt => evt.target.value)
                    // мерджим с событием нажатия Enter
                    .merge(
                        Observable.fromEvent(this.$search.find('input[name="query"]'), 'keyup')
                            .filter(evt => evt.keyCode === 13)
                            .map(_.partial(_.get, _, 'target.value'))
                    )
                    .skipWhile(query => !query)
                    .debounceTime(1000)
                    .do(() => {
                        this.$name('search').show()
                        // сбрасываем выделение на выбраном из поиска объекте
                        this.$search.find('.result')
                            .empty()
                            .children('div[data-item].selected')
                            .removeClass('selected')

                        if (this._searchFeature) {
                            this.currentLayer.setFeatureStyleName(
                                this._searchFeature,
                                this._searchFeature === this.currentFeature ? 'current' : 'default'
                            )
                            this._searchFeature = undefined
                        }
                    })
                    // мапим в запрос на сервер строки более 3 символов
                    .mergeMap(query => {
                        this._searchPromise && this._searchPromise.cancel()

                        this._searchPromise = this.featuresSource.page({
                            options: {
                                geog: false,
                                filter: {
                                    ...this.currentLayer.filter_ || {},
                                    attributes: {
                                        [ this.searchAttribute.id ]: query
                                    }
                                }
                            },
                            limit: 100
                        })

                        return Observable.from(this._searchPromise)
                    })
                    // вытаскиваем итемы
                    .map(_.partial(_.get, _, 'items'))
                    .subscribe(
                        items => {
                            this.$name('search').hide()
                            // выводим результат в список
                            const $result = this.$search.find('.result').empty()

                            if (!_.isEmpty(items)) {
                                $result.append(
                                    ...items.map(
                                        item => {
                                            const value = attributeHelper.format(this.searchAttribute, item.attributes[ this.searchAttribute.id ])

                                            return `<hr />
                                                    <div data-item="${item.id}">
                                                        <span title="Номер">${item.id}</span><span title="${this.searchAttribute.name}">${value}</span>
                                                    </div>`
                                        }
                                    )
                                )
                            }
                        },
                        err => {
                            this.$name('search').hide()
                            console.error(err)
                        }
                    )
                // подписываемся на клик по строке результата поиска
                this._searchItemClickSubscription = Observable.fromEventPattern(
                    handler => this.$search.on('click', '.result > div', handler),
                    handler => this.$search.off('click', '.result > div', handler),
                    evt => $(evt.target).closest('[data-item]').data('item')
                )
                    .do(id => {
                        this.$name('search').show()

                        // сбрасываем выделение и подсвечиваем новый
                        this.$search.find('.result > div[data-item].selected').removeClass('selected')
                        this._searchFeature && this.currentLayer.setFeatureStyleName(this._searchFeature, 'default')
                        this.$search.find(`.result > div[data-item="${id}"]`).addClass('selected')
                    })
                    // мапим в запрос объекта с сервера
                    .mergeMap(id => Observable.from(this.featuresSource.get({ id })))
                    .do(() => this.$name('search').hide())
                    // мапим, фильтруем...
                    .map(_.partial(_.get, _, 'item'))
                    .filter(_.negate(_.isEmpty))
                    // перекидываем карту на область с выбранным объектом
                    .do(item => this.map.fit(this.map.geomFromGeoJSON(item.geog), undefined, { padding: [ 30, 30, 30, 30 + this.$search.width() ] }))
                    // мапим объект в фёчер слоя, как только он (фёчер) будет загружен слоем
                    .do(() => this.$name('search').show())
                    .mergeMap(
                        searchItem => {
                            const feature = this.currentLayer.getFeature(searchItem.id)

                            if (feature) return Observable.of(feature)

                            return Observable.fromEvent(this.currentLayer, 'load', _.partial(_.get, _, 'data.items'))
                                .mergeMap(items => {
                                    const item = _.find(items, { id: searchItem.id })

                                    return item ? Observable.of(this.currentLayer.getFeature(item.id)) : Observable.empty()
                                })
                                .first()
                        },
                        (item, feature) => ({ item, feature })
                    )
                    .subscribe(
                        ({ feature }) => {
                            this.$name('search').hide()

                            if (feature !== this.currentFeature) {
                                this.currentLayer.setFeatureStyleName(feature, 'select')
                            }

                            this._searchFeature = feature
                        },
                        err => {
                            this.$name('search').hide()
                            console.error(err)
                        }
                    )
            }
            // подписываемся на изменения режима fullscreen и переключаем режим редактирования карты
            this._fullScreenSubscription = Observable.fromEventPattern(
                handler => $(document).on('fullscreenchange webkitfullscreenchange mozfullscreenchange msfullscreenchange', handler),
                handler => $(document).off('fullscreenchange webkitfullscreenchange mozfullscreenchange msfullscreenchange', handler)
            ).subscribe(
                () => {
                    this.updateElement()
                    // переключение режима карты
                    // fullscreen on - всегда режим редактирования
                    // fullscreen off - режим просмотра
                    if (UI.Util.FullScreen.fullScreenElement() === this.$element[ 0 ]) {
                        this.$element.addClass('fs')
                        // this.currentFeature && this.map.fit(this.currentFeature.getGeometry(), [ 30, 30, 30, 30 + this.$search.width() ])

                        if (this.modeMap === this.Class.Mode.View) this.onEditClick()
                    } else {
                        this.$element.removeClass('fs')
                        // this.currentFeature && this.map.fit(this.currentFeature.getGeometry())

                        if (this.modeMap === this.Class.Mode.Edit) this.onEditClick()
                    }
                },
                ::console.error
            )

            if (this.mode == this.Class.Mode.View) //todo: to interface
            {
                this.$mapModeButton.hide()
                this.$unbindButton.hide()
            }

            this.setCurrentTarget()
            this.initMap()
        },
        async updateFeatureInfo () {
            if (!this.currentFeature) {
                this.$featureInfo.empty()
                this.map.align()
                return
            }

            var info = [];

            // добавление атрибута источника данных
            if (this.currentClass && this.sourceAttribute && this.sourceAttributeDict)
            {
                let value = "&mdash;";
                if (this.currentFeature.values_&& this.currentFeature.values_.attributes) {
                    let attributes = JSON.parse(this.currentFeature.values_.attributes);
                    if (attributes && attributes[this.sourceAttribute.id]) {
                        var dictItem = _.find(this.sourceAttributeDict, (d) => {return d['id'] === attributes[this.sourceAttribute.id];})
                        if (dictItem)
                            value = dictItem['value'];
                    }
                }

                info.push({
                    label: this.sourceAttribute['name'],
                    value: value
                })
            }


            const areaUnits = this.$control.attr('area-units')
            let area = this.currentFeature.get('area')
            if (!Util.isEmpty(areaUnits) || !Util.isEmpty(area)) {
                let areaStr = ''
                switch (areaUnits) {
                    case 'ha':
                        areaStr = _.round(area / 1e4, 3) + ' Га'
                        break
                    case 'km':
                        areaStr = _.round(area / 1e6, 3) + ' км<sup>2</sup>'
                        break
                    case 'm':
                    default:
                        areaStr = _.round(area, 3) + ' м<sup>2</sup>'
                        break
                }
                info.push({
                    label: 'Площадь ' + this.$control.attr("html-title").replace(/\["(.+?)"]/g, '$1') ,
                    value: areaStr
                })
            }

            this.$featureInfo.empty()
            if (info.length) {
                _.each(info, (item) => {
                    let html = `
                        <div class="flex">
                            <span class="title">` + item['label'] + `</span> <span class="value">` + item['value'] + `</span>
                        </div>
                    `;
                    this.$element.find('.feature-info-map').append(html);
                    this.$featureInfo.append(html);
                })
            }

            this.map.align()
        },
        async onEditClick () {
            if (this.mode !== this.Class.Mode.Edit) return //todo: to interface

            this.modeMap = (this.modeMap == this.Class.Mode.Edit ? this.Class.Mode.View : this.Class.Mode.Edit)
            $('div', this.$mapModeButton).removeClass().addClass('icon-21')

            const filter = _.get(this.currentLayer, 'filter_') || {}

            if (this.modeMap == this.Class.Mode.Edit) {

                this.$mapModeButton.attr('Режим просмотра')
                $('div', this.$mapModeButton).addClass('icon-lock2')

                delete filter.id

                if (!UI.Util.FullScreen.isFullScreen()) {
                    UI.Util.FullScreen.requestFullScreen(this.$element.get(0))
                }

                if(parseInt(this.$control.attr('editable')) == 1){
                    this.addDrawControl();
                }
            } else if (this.modeMap == this.Class.Mode.View) {

                this.$mapModeButton.attr('Режим редактирования')
                $('div', this.$mapModeButton).addClass('icon-mode_edit')

                if(parseInt(this.$control.attr('editable')) == 1){
                    await this.saveObjectsChanges();
                }

                const value = this.getValue()
                if (!Util.isEmpty(value)) {
                    filter.id = value
                }

                if (UI.Util.FullScreen.isFullScreen()) {
                    UI.Util.FullScreen.exitFullscreen()
                }
            }

            if (this.currentFeature) {
                this.map.fit(this.currentFeature.getGeometry())
                this.currentFeature = undefined
            }
            this.currentLayer && this.currentLayer.filter(filter)
        },
        /**
         * @protected
         * @returns {GIS.Map.Control.OL3.Draw}
         */
        addDrawControl()
        {
            if(!this.currentLayer) return;

            var draw = (/** @type {GIS.Map.Control.OL3.Draw} */this.map.getControl("draw"));

            if (!draw) {
                let self = this;

                const options = _.assign(GIS.Map.Control.OL3.Draw.defaults(), {
                    layers: [self.currentLayer]
                });

                const geomType = Util.coalesce(_.get(this.currentLayer.data, 'geomtype'), _.get(this.currentLayer.data, 'feature.geomtype'), _.get(this.currentLayer.data, 'class.geomtype'));
                options.drawControls = this.getControlsByType(geomType);
                options.actionControls = ["cancel"];

                draw = (/** @type {GIS.Map.Control.OL3.Draw} */this.map.addControl("draw", GIS.Map.Control.OL3.Draw, options));

                draw.$control.addClass('gis-draw-control-right');

                draw.on("modify.start", this.onDrawControlModify, this);
                draw.on("modify.end", this.onDrawControlModify, this);
                draw.on("remove", function () {}, this);
                draw.on("draw.end", this.onDrawControlDrawEnd, this);
                draw.on('cancel', (data) => {
                    _.each(this.currentLayer.getFeatures(), (f) => {
                        if(this.currentLayer.getFeatureStyleName(f) === 'current')
                            this.currentLayer.setFeatureStyleName(f, 'default', 'default');
                    })
                })
            }

            return draw;
        },
        /**
         * @param {[ol.Feature]} features
         * @protected
         */
        onDrawControlModify({features})
        {
            let feature = _.first(features);
            this.setValue(feature.get('id'), true);
            if(this.currentLayer.getFeatureStyleName() !== 'current'){
                this.currentLayer.setFeatureStyleName(feature, 'current', 'current');
            }
        },
        onDrawControlDrawEnd({feature}){
            const map = this.map.getMap();

            if (this.currentClass.geomtype == null) {
                this.findControl(this.$controls('[target="item.geomtype"]'))
                    .setValue(GIS.Geometry[feature.getGeometry().getType()], true);
            }

            const provider = Util.coalesce(context("provider"), this.currentClass.provider, {});

            const geog = this.map.getMap().geomToGeoJSON(feature.getGeometry(), map.getProjection(), map.displayProjection);
            const layerFeature = {
                geog: geog,
                layerid: this.currentClass.id,
                layeruid: this.currentClass.uid
            };

            const object = {
                class: this.currentClass,
                classname: this.currentClass.name,
                codeid: this.currentClass.codeid,
                classcode: this.currentClass.classcode,
                classcodename: _.get(this.currentClass, 'classcode.name'),
                providerid: provider.id,
                providername: provider.name,
                provider: provider,
                classid: this.currentClass.id,
                classuid: this.currentClass.uid,
                ...layerFeature,
                feature: layerFeature
            };
            _.assign(object, _.pick(this.currentClass, "private", "acl"));

            feature.setProperties(object);

            const draw = this.map.getControl("draw");
            draw.drawEnd(false, true);
            draw.selectFeatureOnMap(feature);

            this.currentLayer.insert(feature);
            this.onFeatureSelect({feature});

            this.map.refresh();
        },
        saveObjectsChanges(){
            const draw = this.map.getControl("draw");

            const promises = [];

            this.showSpinner();

            if (draw && this.canDrawObjects()) {
                promises.push(this.saveObjects());
            }

            return Promise.all(promises).return(this.currentClass)
                .then((item) => {
                    this.currentClass = null;
                    this.disabled = true;
                    this.map && this.map.removeControl("draw");
                    this.disabled = false;

                    this.map.refresh();

                    application.ui.notify(`Объекты класса пространственных данных <b>${Util.coalesce(item.name, item.uid, item.id)}</b> сохранены.`);

                    return item;
                })
                .catch(err => console.warn(err.stack))
                .finally(() => {this.hideSpinner()});
        },
        async saveObjects() {
            /** @type {GIS.Map.OL3} */
            const map = this.map.getMap();
            /** @type {GIS.Map.Control.OL3.Draw} */
            const draw = this.map.getControl("draw");

            const self = this;
            const modified = draw.getModified().items();

            const promises = _.map(
                draw.getDrawn().items().slice().concat(modified), async (feature, i) => {
                    if(feature.get('id')) {
                        await this.objectsSource.getDocument({id: feature.get('id')}).then(({item}) => {
                            feature.setProperties(item)
                        });
                    }

                    const object = map.pickFeatureProperties(feature);
                    object.geog = map.geomToGeoJSON(feature.getGeometry(), map.getProjection(), map.displayProjection);

                    return this.addPromise("saveObject" + i, this.objectsSource.saveDocument(object))
                        .then((data) => {
                            if (!self.getValue())
                                self.setValue(data.item.id)
                        });
                })
                .concat(draw.getRemoved().map((feature, i) => {
                    if (feature.get("id")) {
                        return this.addPromise("removeObject" + i, this.objectsSource.remove({id: feature.get("id")}))
                            .then((data) => {
                                return data;
                            });
                    }
                }))
                .filter(_.identity);

            return Promise.all(promises).then((result) => {
                return result;
            });
        },
        updateElement () {
            this.map.align()
        },
        removeElement () {
            this._searchInputSubscription && this._searchInputSubscription.unsubscribe()
            this._searchItemClickSubscription && this._searchItemClickSubscription.unsubscribe()
            this._fullScreenSubscription && this._fullScreenSubscription.unsubscribe()

            this.ParentCall()

            this.map && this.map.destroy()
            this.currentLayer && this.currentLayer.destroy()
            this._searchPromise && this._searchPromise.cancel()

            this.$selector = this.$map = this.currentFeature =
                this.$unbindButton = this.$featureInfo = this.$search =
                    this.featuresSource = this._searchInputSubscription = this._searchItemClickSubscription =
                        this._searchPromise = this._searchFeature = this._fullScreenSubscription = null
        },
        async initMap () {
            this.map = new GIS.UI.Map(this, {
                'class': _.get(global, this.$control.attr('map'), GIS.Map.OL3),
                layersSourceClass: Util.coalesce(this.$control.attr('layer-source'), 'GIS.Data.Layers'),
                featuresSourceClass: Util.coalesce(this.$control.attr('feature-source'), 'GIS.Data.LayerFeatures'),
                center: JSON.parse(Util.coalesce(this.$control.attr('map-center'), '[0, 0]')),
                zoom: Util.coalesce(this.$control.attr('map-zoom'), 3),
                // renderer: ['webgl', 'canvas'],
                initControls: {
                    fullscreen: false
                },
                interactionOptions: {
                    select: {
                        condition: evt => this.modeMap === this.Class.Mode.Edit && eventsCondition.doubleClick(evt),
                        toggleCondition: evt => !!this.map.getMap().forEachFeatureAtPixel(evt.pixel, feature => feature === this.currentFeature)
                    }
                }
            }).render().appendTo(this.$map)

            this.featuresSource = Util.create(this.map.featuresSourceClass)

            this.map.on('destroy', () => {
                this.map = this.featuresSource = this.currentLayer = this.currentFeature = null
            })

            try {
                await new Promise(resolve => {
                    this.map.once("ready", () => {
                        this.map.align()
                        resolve(this.map)
                    })
                })
                await this.initLayer(this.map)

                return this.map
            } catch (err) {
                console.warn(err.stack)
            }
        },
        async initLayer (map) {
            application.ui.spinnerStart()

            try {
                const [ layer ] = await Promise.all([
                    this.showLayer(map),
                    this.fitFeature(map)
                ])

                this.currentLayer = layer
                const onLoad = () => {
                    const value = this.getValue()

                    if (!this.currentFeature) {
                        this.currentFeature = layer.getFeature(value)
                        if (this.currentFeature) {
                            this.updateFeatureInfo()
                            this.map.getMap().fit(this.currentFeature.getGeometry())
                        }
                    }

                    if (this.currentFeature && layer.getFeatureStyleName(this.currentFeature) !== 'current') {
                        if(this.modeMap == this.Class.Mode.Edit){
                            const draw = this.map.getControl('draw');
                            if(draw)
                                draw.selectFeatureOnMap(this.currentFeature);
                        }
                        layer.setFeatureStyleName(this.currentFeature, 'current', 'current')
                    }
                }

                layer.on('destroy', () => this.currentLayer = this.currentFeature = null)
                    .on('before.load', ({ first }) => {if (first) {
                        this.$name('filter').show()
                        application.ui.spinnerStart()
                    }})
                    .on('load', onLoad)
                    .on('after.load', ({ last }) => {if (last) {
                        application.ui.spinnerStop()
                        this.$name('filter').hide()
                    }})
                    .on('feature.select', this.onFeatureSelect.bind(this))
                    .on('feature.unselect', ({ feature }) => {
                        this.currentFeature = null
                        layer.setFeatureStyleName(feature, 'default', 'default')
                        this.setValue(null, true)
                        this.updateFeatureInfo()
                    })

                return layer
            } finally {
                application.ui.spinnerStop()
            }
        },

        onFeatureSelect({ feature }){
            if (this.currentFeature) {
                this.currentLayer.setFeatureStyleName(this.currentFeature, 'default', 'default')
            }

            const self = this;

            this.currentFeature = feature
            this.currentLayer.setFeatureStyleName(this.currentFeature, 'current', 'current')
            this.setValue(this.currentFeature.get('id'), true)
            this.updateFeatureInfo()
        },

        async showLayer (map) {
            const options = {}
            const value = this.getValue()

            if (this.modeMap == this.Class.Mode.View && !Util.isEmpty(value)) {
                if (this.getValue()) _.set(options, 'filter.id', value)
            }

            const layer = await map.showLayer(this.extractCurrentAttribute('layer'), true, options)

            // не надо центрировать карту на слой, если карта уже отцентрирована на объект
            if (!this.fitFeatureCalled__) {
                const extent = _.get(layer, 'data.extent', _.get(layer, 'data.layer.extent'))
                const { zoom, center } = Util.coalesce(_.get(layer, 'data.options'), _.get(layer, 'data.layer.options'), {})

                if (extent && extent.length) {
                    map.fit(
                        map.transformExtentProjection(
                            extent,
                            GLONASS_PROJ,
                            map.getProjection()
                        ),
                        undefined,
                        {
                            maxZoom: 15
                        }
                    )
                } else if (center != null) {
                    map.setCenter(
                        center && center.coordinates ?
                            map.transformCoordinateProjection(
                                center.coordinates,
                                GLONASS_PROJ,
                                map.getProjection()
                            ) :
                            map.getCenter(),
                        zoom != null ? zoom : map.getZoom()
                    )
                }
            }

            return layer
        },
        async fitFeature (map) {
            const value = this.getValue()

            if (!value) {
                return map
            }

            this.fitFeatureCalled__ = false

            const { item } = await this.featuresSource.get({ id: value })
            const geog = _.get(item, 'geog', _.get(item, 'feature.geog'))

            if (geog) {
                map.fit(map.geomFromGeoJSON(geog))
                this.fitFeatureCalled__ = true
            }

            return map
        },
        getIndex () {
            return $("option:selected", this.$selector).index()
        },
        extractCurrentAttribute (attributeName) {
            return JSON.parse(this.$control.attr(attributeName))[ this.getIndex() ]
        },
        setCurrentTarget () {
            this.target = JSON.parse(this.$control.attr('target'))[ this.getIndex() ]
        },

        /**
         * Returns array of draw controls based on class geomtype
         * @param {number} [geomType] GIS.Geometry
         * @returns array
         * @protected
         */
        getControlsByType(geomType) {
            let controls = [];
            switch (+GIS.Geometry.simpleId(geomType)){
                case GIS.Geometry.Point:
                    controls = ["draw-point"];
                    break;
                case GIS.Geometry.LineString:
                    controls = ["draw-line"];
                    break;
                case GIS.Geometry.Polygon:
                    controls = ["draw-polygon"];
                    break;
                default:
                    controls = [];
            }

            controls = _.concat(controls, ["draw-by-coordinates", "modify", "forcedRemove"]);

            return controls;
        },

        showSpinner(){
            this.$mapModeButton.hide();
            this.$spinner.show();
        },

        hideSpinner(){
            this.$mapModeButton.show();
            this.$spinner.hide();
        }
    }
)
